<header #pageHeader class="fixed-top">
  <nav>
    <img src="../../../assets/img/velmaral-banner.jpg" class="img-fluid header-img" alt="Event"
      (load)="onHeaderImageLoad()" decoding="async" />
  </nav>
</header>
<div class="bg-wrapper" #bgWrapper>

    <div class="container mt-4">

        <h5 class="mb-3 mt-5 text-color text-center text-bold">நிகழ்ச்சி கருத்து பதிவு</h5>

        <div class="card shadow">

            <div class="card-body">
                <form [formGroup]="feedbackForm" (ngSubmit)="submitForm()">

                    <!-- Name & City -->
                    <div class="row mb-3">

                        <div class="col-md-12 mb-5">
                            <label class="form-label">நிகழ்ச்சியைத் தேர்வு செய்யவும்</label>
                            <br>
                            <select class="form-select" formControlName="eventId"
                                [class.is-invalid]="submitted && feedbackForm.get('eventId')?.invalid">
                                <option value="">-- தேர்வு செய்யவும் --</option>
                                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">
                                    {{event.eventName}} -
                                    {{event.city}} -
                                    {{formattedDate(event?.eventDate)}}</option>
                            </select>
                        </div>

                        <div class="col-md-12 mb-3">
                            <label class="form-label">பெயர் *</label>
                            <input type="text" class="form-control" formControlName="name"
                                [class.is-invalid]="submitted && feedbackForm.get('name')?.invalid">
                        </div>

                        <div class="col-md-6 mb-3">
                            <label class="form-label fw-bold">மாநிலம் / யூ பிரதேசம் (State / UT) *</label>

                            <br>

                            <select class="form-select form-select-lg p-1" formControlName="state">
                                <option value="" disabled selected>Select any one</option>
                                <option *ngFor="let s of statesList" [value]="s.value">
                                    {{ s.label }}
                                </option>
                            </select>
                        </div>


                        <!-- ====== DISTRICT ====== -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label fw-bold">மாவட்டம் (District) *</label>

                            <br>
                            <select class="form-select form-select-lg p-1" formControlName="city">
                                <option value="" disabled selected>Select any one</option>

                                <option *ngFor="let d of districtList" [value]="d.value">
                                    {{ d.label }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="mb-3">
                        <label class="form-label">📧 மின்னஞ்சல் முகவரி *</label>
                        <input type="email" class="form-control" formControlName="email"
                            [class.is-invalid]="submitted && feedbackForm.get('email')?.invalid">
                    </div>

                    <!-- Overall Experience -->
                    <div class="mb-3 mt-3">
                        <label class="form-label">📌 மொத்த அனுபவம் *</label>

                        <div class="form-check"
                            *ngFor="let exp of ['மிகச் சிறந்தது','மிகவும் நல்லது','நல்லது','சராசரி','மேம்படுத்த வேண்டும்']">
                            <input class="form-check-input" type="radio" formControlName="overallExperience"
                                [value]="exp">
                            <label class="form-check-label">{{ exp }}</label>
                        </div>
                    </div>

                    <!-- Favorite Aspect -->
                    <div class="mb-3 mt-3">
                        <label class="form-label">❤️ மிகவும் பிடித்த அம்சம் *</label>

                        <div class="form-check" *ngFor="let fav of [
         'நிகழ்ச்சி உள்ளடக்கம்',
         'ஏற்பாட்டாளர்கள் / தொகுப்பாளர்கள்',
         'நிகழ்ச்சி ஒழுங்கமைப்பு',
         'பங்கேற்பாளர்களுடன் தொடர்பு',
         'நிகழ்ச்சி சூழல்'
       ]">
                            <input class="form-check-input" type="checkbox"
                                (change)="onCheckboxChange($event, 'mostLiked')" [value]="fav">
                            <label class="form-check-label">{{ fav }}</label>
                        </div>
                    </div>

                    <!-- Improvements (Checkbox) -->
                    <div class="mb-3 mt-3">
                        <label class="form-label">🔧 மேம்படுத்த வேண்டியவை *</label>

                        <div class="form-check" *ngFor="let imp of [
         'நிகழ்ச்சி நேர ஒழுங்கு',
         'ஒலி / காட்சி அமைப்பு',
         'அமர்வு வசதி',
         'முன் தகவல் தொடர்பு',
         'உணவு / குடிநீர் வசதி',
         'ஒன்றுமில்லை'
       ]">
                            <input class="form-check-input" type="checkbox"
                                (change)="onCheckboxChange($event, 'improvements')" [value]="imp">
                            <label class="form-check-label">{{ imp }}</label>
                        </div>
                    </div>





                    <!-- Best Team -->

                    <div class="mb-3 mt-3">
                        <label class="form-label">🧑‍🤝‍🧑 சிறந்த குழு *</label>

                        <div class="form-check" *ngFor="let team of [
         'மேடை உதவியாளர்கள்',
              'விளக்கு ஏற்றும் குழு',
              'பதிவு & வரவேற்பு குழு',
              'குடிநீர் வழங்கும் குழு',
              'சுத்தம் & சுகாதார குழு',
              'அமர்வு ஏற்பாடு குழு',
              'அன்னதானம் குழு',
              'பாதுகாப்பு குழு',
              'கணக்கு / நிதி குழு'
       ]">
                            <input class="form-check-input" type="checkbox"
                                (change)="onCheckboxChange($event, 'bestTeamOrSection')" [value]="team">
                            <label class="form-check-label">{{ team }}</label>
                        </div>
                    </div>

                    <!-- Participate Again -->
                    <div class="mb-3 mt-3">
                        <label class="form-label">🔄 மீண்டும் பங்கேற்பீர்களா? *</label>

                        <div class="form-check"
                            *ngFor="let opt of ['கண்டிப்பாக','வாய்ப்பிருந்தால்','உறுதியாக சொல்ல முடியாது','இல்லை']">
                            <input class="form-check-input" type="radio" formControlName="willParticipateAgain"
                                [value]="opt">
                            <label class="form-check-label">{{ opt }}</label>
                        </div>
                    </div>

                    <!-- Additional Comments -->
                    <div class="mb-3">
                        <label class="form-label">💬 கூடுதல் கருத்து (Optional)</label>
                        <textarea class="form-control" rows="3" formControlName="additionalComments"></textarea>
                    </div>

                    <!-- Submit -->
                    <div class="text-center">
                        <button type="submit" class="btn btn-success">
                            Submit Feedback (மதிப்பீடு சமர்ப்பிக்க)
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>


</div>